import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import {
  TableContainer, TableRow, TableCell, Paper, Button, Table, TableBody, Grid
} from '@mui/material';
import call from 'src/core/services/http';
import { CustomCell, CustomRow } from 'src/shared/TableComponents/TableStyles';
import ListHead from 'src/shared/TableComponents/ListHead';
import { toast } from 'react-toastify';
import SpinnerLoader from "../../../shared/plugin/loader/SpinnerLoader";
import { LoadingButton } from '@mui/lab';
import { fDateTime } from 'src/shared/utils/formatTime';
import Label from 'src/shared/components/label/Label';



const TABLE_HEAD = [
  { id: 'recipient_name', label: "Name", alignLeft: true },
  { id: 'recipient_account_number', label: "Account Number", alignLeft: true },
  { id: 'amount', label: " Amount", alignLeft: true },
  { id: 'reference', label: " Reference", alignLeft: true },
  { id: 'mobile_number', label: "Mobile Number", alignLeft: true },
  { id: 'document_number', label: "ID Number", alignLeft: true },
  // { id: 'channel_code', label: "Channel", alignLeft: true },
  { id: 'created_at', label: "Date", alignLeft: true },
  { id: 'status', label: "status", alignLeft: true },
];

function ViewUnprocessedRecords({ item }) {
  const [shop] = useLocalStorage('shop-details');
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [row, setrow] = useState({})
  const [isNotFound, setIsNotFound] = useState(false);
  const [selected, setSelected] = useState([]);


  const getSingleRecordList = async () => {
    try {
      // alert(item.id)
      const response = await call('get', `/wage-disbursement/${item.id}/process/upload-payment-wages/`);
      if (response.data.status) {
        setData(response.data);
        console.log(response.data)
        setIsLoading(false);
        if (response.data.result.bulk_uploads_details.length === 0) {
          setIsNotFound(true);
        }
      } else {
        toast.error(response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSingleRecordList();
  }, []);


  return (
    <>


      <CardContent>
        <Typography sx={{ fontSize: 18 }} color="text.error" gutterBottom>
          List of Beneficiaries
        </Typography>
      </CardContent>

      {isLoading ? (
        <Grid container sx={{ justifyContent: 'center' }}> <SpinnerLoader /></Grid>
      ) : (
        <TableContainer sx={{ overflow: "auto" }}>
          <Table>
            <ListHead
              headLabel={TABLE_HEAD}
              numSelected={Object.keys(selected).length}
            />


            {isNotFound ? (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography variant="h6" paragraph>
                        Not found
                      </Typography>
                      <Typography variant="body2">
                        No results found for <strong>{shop.account_number}</strong>
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {data?.result?.bulk_uploads_details?.map((row, index) => {
                  const { id, recipient_name, recipient_account_number, amount, reference, mobile_number, document_number, channel_code, created_at, status } = row;
                  const rowNumber = index + 1;

                  return (
                    <CustomRow hover key={id} >
                      <CustomCell >{recipient_name}</CustomCell>
                      <CustomCell >{recipient_account_number}</CustomCell>
                      <CustomCell >{amount}</CustomCell>
                      <CustomCell >{reference}</CustomCell>
                      <CustomCell >{mobile_number}</CustomCell>
                      <CustomCell >{document_number}</CustomCell>
                      {/* <CustomCell >{channel_code}</CustomCell> */}
                      <CustomCell >{fDateTime(created_at)}</CustomCell>
                      <CustomCell>
                       {status ? <Label color='info'>Processed</Label> :<Label color='error'>Pending</Label>}
                      </CustomCell>
                    </CustomRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      )}
    </>
  );
}

export default ViewUnprocessedRecords;
